import * as React from "react";
const SvgLock = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.325 2h.088a4.924 4.924 0 0 1 4.874 4.969v3.423h2.587a.77.77 0 0 1 .77.769v10.07a.77.77 0 0 1-.77.769H4.769A.77.77 0 0 1 4 21.23V11.162a.77.77 0 0 1 .77-.77h2.587V6.874A4.924 4.924 0 0 1 12.325 2m-3.43 8.392h6.853V6.958a3.385 3.385 0 0 0-3.347-3.42h-.087a3.385 3.385 0 0 0-3.419 3.347zM5.538 11.93v8.532h13.567V11.93zm6.784 3.357a.91.91 0 1 0 0 1.818.91.91 0 0 0 0-1.818m-2.448.909a2.448 2.448 0 1 1 4.895 0 2.448 2.448 0 0 1-4.895 0",
    clipRule: "evenodd"
  }
));
export default SvgLock;
